<template>
    <section>
      <el-form ref="form" label-position="right" status-icon :model="form" :rules="rules" label-width="150px" style="width:95%;overflow:auto">
        <el-form-item label="设备编号" prop="id">
          <el-input placeholder="请输入设备编号" v-model="form.id" :disabled="row ? true : false"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择类型" @change="chooseType">
            <el-option
              v-for="item in typeOptions"
              :key="item.code"
              :label="item.desc"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属商户" prop="merchantId" v-if="userInfo.roleLevel < 5 && ( (row && !row.merchantId) || !row)">
          <el-select v-model="form.merchantId" placeholder="请选择所属商户" @change="chooseMerchant">
            <el-option
              v-for="item in managerUnitOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安装小区" prop="unitId"  v-if="userInfo.roleLevel <= 5">
          <el-select filterable remote v-model="form.unitId" clearable placeholder="请输入小区名称查询" :remote-method="getNieghbourList">
            <el-option
              v-for="item in neighbourhoodList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车位具体位置" prop="location">
          <el-input placeholder="请填写车位具体位置" v-model="form.location"></el-input>
        </el-form-item>
        <el-form-item label="是否有充电桩" prop="isHaveChargingPile">
           <el-radio-group v-model="form.isHaveChargingPile">
             <el-radio-button :label="1">有</el-radio-button>
             <el-radio-button :label="0">无</el-radio-button>
           </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button @click="close('form')">取消</el-button>
          <el-button type="primary" @click="handleSubmit('form')" :plain='true'>立即提交</el-button>
        </el-form-item>
      </el-form>
    </section>
  </template>
  
  <script>
  import { addFloorLock,getNeighbourhoodList,editFloorLock,getMerchantList,getFloorLockTypeList } from '@/api/public.js';
  export default {
    props:['row'], // 父组件携带参数
    data() {
      return {
        form:{ // 表单数据
          parkNum: "", // 车位号
          id: "", // 设备编号
          unitId: "", // 小区id
        },
        rules: { // 表单验证
          id:[
            { required: true, message: '设备编号不得为空', trigger: 'blur',}
          ],
          unitId:[
            { required:true,message:'安装小区不得为空',trigger:"blur"}
          ],
          location:[
            { required:true,message:'车位具体位置不得为空',trigger:"blur"}
          ],
          type:[
            { required:true,message:'请选择设备类型',trigger:"blur"}
          ],
          merchantId:[
            { required:true,message:'请选择所属商户',trigger:"blur"}
          ],
          isHaveChargingPile:[
            { required:true,message:'请选择是否有充电桩',trigger:"change"}
          ]
        },
        workDates:null,
        neighbourhoodList:[], // 小区列表
        managerUnitOptions:[], // 商户列表
        unitId:[],
        typeOptions:[], // 类型列表
        userInfo:JSON.parse(localStorage.getItem('userInfo'))
      };
    },
  
    components: {},
  
    computed: {},
  
    mounted() {
      this.form = this.row ? {...this.row} : this.form;
      this.getMerchantOptions();
      this.getNieghbourList(null);
      this.getTypeList();
    },
  
    methods: {
      async getTypeList(){
        await getFloorLockTypeList({}).then(res=>{
          if(res.success){
            this.typeOptions = res.data;
          }else{
            this.typeOptions = [];
          }
        })
      },
      // 获取小区列表
      getNieghbourList(e){
        let data = {
          pageNo:1,
          pageSize:1000,
          param:{
            name:e,
            merchantId:this.form.merchantId,
          }
        }
        getNeighbourhoodList(data).then(res=>{
          if(res.success){
            this.neighbourhoodList = res.data.list;
          }
        })
      },
      // 获取商户列表
      async getMerchantOptions(){
        let data = {
          pageNo:1,
          pageSize:1000,
          param:{
            name:'',
          }
        }
        await getMerchantList(data).then(res=>{
          if(res.success){
            this.managerUnitOptions = res.data.list;
          }else{
            this.managerUnitOptions = [];
          }
        })
      },
      // 选择商户、小区
      chooseMerchant(e){
        this.form.merchantId = e;
        this.getNieghbourList();
      },
      // 关闭弹窗
      close(form){
         this.$emit('close');
      },
      // 新增
      async add(){
        await addFloorLock({param:this.form}).then((res) => {
          if (res.success) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            setTimeout(() => {
              this.$emit("close");
              this.init();
            }, 1000);
          }else{
            this.$message({
              message: res.msg,
              type: "fail",
            });
          }
        })
      },
      // 编辑
      async edit(){
        await editFloorLock({param:this.form}).then((res) => {
          if (res.success) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            setTimeout(() => {
              this.$emit("close");
              this.init();
            }, 1000);
          }else{
            this.$message({
              message: res.msg,
              type: "fail",
            });
          }
        })
      },
      // 提交
      handleSubmit(form) {
        if(this.userInfo.roleLevel >= 10){
          this.form.unitId = this.userInfo.unitId;
        }
         this.$refs["form"].validate(valid => {
            if (valid) {
                this.$confirm('确认提交吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(()=>{
                  if(this.row){
                    this.edit();
                  }else{
                    this.add();
                  }
                })
            }else{
              return false;
            }
        });
      },
    }
  };
  </script>
  <style lang="scss" scoped>
  // 防止地图自动完成的对象被遮挡
  .tangram-suggestion {
      z-index: 9999 !important;
    }
   .el-drawer{
     overflow:auto !important;
   }
   /deep/ .el-form-item__content{
    display: flex;
   }
   .map{
    border: 1px solid #dcdfe6;
    background: #fff;
    border-radius: 4px;
    width: 80px;
   }
   .avatar-uploader .el-upload {
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      border: 1px dashed #ccc;
      border-radius: 50%;
      overflow:hidden;
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  </style>
  